module.exports = __webpack_public_path__ + "static/media/arrow.3e2b89c8.png";